import { render, staticRenderFns } from "./DoctorsPractice.vue?vue&type=template&id=4b168652&scoped=true&"
import script from "./DoctorsPractice.vue?vue&type=script&lang=js&"
export * from "./DoctorsPractice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b168652",
  null
  
)

export default component.exports